import React from 'react'
import { View } from 'react-native'
import { BtText, BtCheckBox } from '@linqpal/components/src/ui'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import {
  IconArrowRightLightly,
  NewAttchmentIcon,
} from '../../../../assets/icons'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { currencyMask } from '../../../../utils/helpers/masking'
import { Status } from '../../../../ui/atoms/Status'
import { paths } from '../../../links'
import { invoiceStatus } from '@linqpal/models/src/dictionaries'
import { statusBadge } from '@linqpal/models/src/dictionaries/invoiceStatus'

interface GroupedInvoicItemProps {
  invoice: any
  onSelect: (arg: string) => void
  navigation: any
}

export const GroupedInvoicItem: React.FC<GroupedInvoicItemProps> = ({
  invoice,
  onSelect,
  navigation,
}) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 14 }}>
      <BtCheckBox
        checked={invoice.selected}
        onPress={() => onSelect(invoice._id)}
      />
      <BtText
        style={{ flex: 1, marginLeft: 8 }}
        numberOfLines={1}
        ellipsizeMode="tail"
        size={16}
      >
        #{invoice.invoice_number}
      </BtText>
      <BtText
        style={{ marginLeft: 8, marginRight: 3 }}
        weight={'700'}
        size={16}
      >
        {currencyMask(invoice.total_amount)}
      </BtText>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {invoice.status === invoiceStatus.pastDue ? (
          <Status
            style={{ marginRight: 5 }}
            label={statusBadge[invoice.status]?.label}
            textColor={statusBadge[invoice.status]?.textColor}
          />
        ) : null}
        {invoice.invoice_document ? (
          <GetIcon
            icon={<NewAttchmentIcon height="20" width="20" />}
            onPress={() => {
              navigation.navigate(paths.Console.Payables.AttachmentPreview, {
                id: invoice._id,
              })
            }}
          />
        ) : (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate(paths.Console.Payables.Invoice, {
                id: invoice._id,
              })
            }}
          >
            <IconArrowRightLightly
              height={20}
              width={30}
              style={{ width: 40 }}
            />
          </TouchableOpacity>
        )}
      </View>
    </View>
  )
}
